var _title, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTimemachine = function SvgTimemachine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: 96,
    height: 96,
    className: "rounded",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "time machine")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.979,7.047A23.848,23.848,0,0,0,24.011.01H24A24,24,0,0,0,0,24a2,2,0,0,0,2,2H2a2,2,0,0,0,2-2A20,20,0,0,1,24,4.01h.01a20,20,0,1,1-.009,40h-.009a20.041,20.041,0,0,1-10.74-3.169l3.254-2.76a1,1,0,0,0-.378-1.727L4.742,33.183a1,1,0,0,0-1.232.694.989.989,0,0,0-.029.394L4.939,45.865a1,1,0,0,0,1.639.638l3.488-2.959A24.088,24.088,0,0,0,23.989,48.01H24A24,24,0,0,0,40.979,7.047Z",
    fill: "#aeaeae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5,25.5a1.5,1.5,0,0,0,0-3l-12.567-.433L25.5,9.5a1.5,1.5,0,0,0-3,0L22,24a2,2,0,0,0,2,2Z",
    fill: "#363636"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTimemachine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/time machine.10759997.svg";
export { ForwardRef as ReactComponent };